import { DisabledPrevButtonType, Selected } from '../reducers/app/appTypes';
import { SearchState } from '../reducers/search/searchTypes';
import { isBrowser } from './browserHelper';

type BokaSession = {
  operation: string;
  selected: Selected;
  search: SearchState;
  from: string;
  disabledPrevButton: DisabledPrevButtonType;
};

type UpdateSessionItem = (
  key: keyof BokaSession,
  value: string | Partial<Selected> | Partial<SearchState>,
) => void;

const BOKA_SESSION = 'boka_session';
const INITIAL_SESSION: BokaSession = {
  operation: '',
  selected: {
    // TODO: Will be added in upcoming PR
    // serviceCode: '',
    serviceId: '',
    storeId: 'default',
    timeSlot: null,
  },
  search: {
    postCode: '',
    city: '',
    address: '',
    state: '',
  },
  from: '',
  disabledPrevButton: '',
};

export const getSession = (): BokaSession => {
  if (!isBrowser()) {
    return INITIAL_SESSION;
  }

  const bokaSession = sessionStorage.getItem(BOKA_SESSION);
  return bokaSession ? JSON.parse(bokaSession) : INITIAL_SESSION;
};

const saveSession = (session: BokaSession) => {
  if (!isBrowser()) return;
  sessionStorage.setItem(BOKA_SESSION, JSON.stringify(session));
};

export const updateSessionItem: UpdateSessionItem = (key, value) => {
  if (!isBrowser()) return;

  const session = getSession();
  if (key === 'selected' && typeof value === 'object') {
    const updatedSession = {
      ...session,
      selected: {
        ...session.selected,
        ...value,
      },
    };
    saveSession(updatedSession);
  } else if (key === 'search' && typeof value === 'object') {
    const updatedSession = {
      ...session,
      search: {
        ...session.search,
        ...value,
      },
    };
    saveSession(updatedSession);
  } else {
    const updatedSession = {
      ...session,
      [key]: value,
    };
    saveSession(updatedSession);
  }
};

export const clearSession = () => {
  if (!isBrowser()) return;
  sessionStorage.removeItem(BOKA_SESSION);
};
